export default __webpack_public_path__ + "static/media/image1.79905de5.jpg";